import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend } from "recharts";
import { Card } from "@/components/ui/card";
import { TrendingUp } from "lucide-react";

const rate = (n, d) => (d ? Math.round((n / d) * 100) : 0);

export default function CampaignCompare({ campaigns }) {
  const done = campaigns.filter((c) => c.status === "completed" && c.unique_phones > 0).slice(0, 10).reverse();
  if (done.length < 2) return null;
  const data = done.map((c) => ({
    id: c.id,
    name: c.name.length > 18 ? c.name.slice(0, 17) + "…" : c.name,
    risposta: rate(c.replies || 0, c.unique_phones),
    rigiocata: rate(c.replays || 0, c.unique_phones),
    replies: c.replies || 0,
    replays: c.replays || 0,
    reached: c.unique_phones,
  }));
  const avg = (k) => Math.round(data.reduce((a, d) => a + d[k], 0) / data.length);
  const best = data.reduce((a, d) => (d.risposta > a.risposta ? d : a), data[0]);
  return (
    <Card className="p-5 bg-card border-border" data-testid="campaign-compare">
      <div className="flex items-center gap-2 mb-1">
        <TrendingUp className="h-4 w-4 text-primary" />
        <h3 className="font-display font-bold">Confronto campagne</h3>
        <span className="text-xs text-muted-foreground ml-auto">ultime {data.length} completate</span>
      </div>
      <div className="grid grid-cols-3 gap-2 my-3 text-center">
        <div className="rounded-lg bg-secondary/40 p-2" data-testid="compare-avg-reply"><div className="text-[10px] uppercase text-muted-foreground">Media risposta</div><div className="font-display font-black text-xl">{avg("risposta")}%</div></div>
        <div className="rounded-lg bg-secondary/40 p-2" data-testid="compare-avg-replay"><div className="text-[10px] uppercase text-muted-foreground">Media rigiocata</div><div className="font-display font-black text-xl">{avg("rigiocata")}%</div></div>
        <div className="rounded-lg bg-primary/10 border border-primary/30 p-2" data-testid="compare-best"><div className="text-[10px] uppercase text-muted-foreground">Migliore</div><div className="font-semibold text-sm truncate">{best.name}</div><div className="text-xs text-primary">{best.risposta}% risposta</div></div>
      </div>
      <div className="h-56">
        <ResponsiveContainer width="100%" height="100%">
          <BarChart data={data} margin={{ top: 4, right: 8, left: -20, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.06)" />
            <XAxis dataKey="name" tick={{ fontSize: 10 }} interval={0} />
            <YAxis unit="%" tick={{ fontSize: 10 }} domain={[0, 100]} />
            <Tooltip
              contentStyle={{ background: "hsl(var(--card))", border: "1px solid hsl(var(--border))", borderRadius: 8, fontSize: 12 }}
              formatter={(v, k, { payload }) => [`${v}% (${k === "risposta" ? payload.replies : payload.replays} su ${payload.reached})`, k === "risposta" ? "Tasso di risposta" : "Tasso di rigiocata"]}
            />
            <Legend wrapperStyle={{ fontSize: 11 }} formatter={(v) => (v === "risposta" ? "Risposta %" : "Rigiocata %")} />
            <Bar dataKey="risposta" fill="#25D366" radius={[4, 4, 0, 0]} />
            <Bar dataKey="rigiocata" fill="#f59e0b" radius={[4, 4, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}
